// Custom tables with relationship columns pointing at a record surface as
// dynamic tabs after a page's static set. Tab names are namespaced
// `linked:<slug>:<field_id>` so they can't collide with static tab names
// and round-trip through each page's `:tab` route param.
export const linkedTabName = entry => `linked:${entry.slug}:${entry.field_id}`;

export const parseLinkedTab = name => {
  if (typeof name !== "string" || !name.startsWith("linked:")) return null;
  const [, slug, fieldId] = name.split(":");
  return slug && fieldId ? { slug, fieldId } : null;
};
